import { EllipsisLoader } from './EllipsisLoader';

export default EllipsisLoader;
